module.exports = __webpack_public_path__ + "img/4.aaded051.jpg";